import { render, staticRenderFns } from "./DealerTypeField.vue?vue&type=template&id=5fb7025e&"
import script from "./DealerTypeField.vue?vue&type=script&lang=js&"
export * from "./DealerTypeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports